import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/ideal-body-weight-calculator',
  component: () => import('../../routes/IdealBodyWeight.svelte'),
  card: {
    id: 'ideal-body-weight',
    title: 'Ideal Body Weight (IBW)',
    description: 'Calculate your ideal body weight using Devine, Robinson, Miller, and Hamwi formulas. Includes adjusted IBW for non-standard heights.',
    icon: 'monitor_weight',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/ideal-body-weight-calculator',
    category: 'Weight & Nutrition',
  },
  seo: {
    title: 'Ideal Body Weight (IBW) Calculator – Devine, Robinson, Miller & Hamwi',
    description: 'Free IBW calculator using four clinical formulas. Calculate ideal body weight for medication dosing, fitness goals, and health assessment.',
  },
};

export default meta;
